<div class="flex justify-between px-14 md:mt-[-10px] md:px-6">
    <img
        class="md:h-18 md:w-18 h-28 w-32 cursor-pointer sm:h-20 sm:w-20"
        alt="logo"
        [src]="Logo.MALOU | logoPathResolver: { extension: 'svg' }"
        (click)="redirectToMalouWebSite()" />
    <div class="flex items-center">
        <app-menu-select [options]="langs" [currentOption]="currentLang" (selectionChange)="changeLang($event)"> </app-menu-select>
    </div>
</div>
